import axiosInstance from '../axiosConfigCMS';

export default {
  async getLogin() {
    const response = await axiosInstance.get('/login');
    return response.data;
  },
};
